<!--
 * @Author: 汪俊洪
 * @Date: 2023-10-23 15:47:21
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2023-10-27 08:57:21
 * @Description:
-->
<template>
  <div>
    <div>
      <h3>基本信息</h3>
      <h4>{{ detail.projName }}</h4>
      <div class="list">
        <div class="item">
          <span class="label">客户名称：</span>
          <span class="value">{{ detail.custName }}</span>
        </div>
        <div class="item">
          <span class="label">最终客户名称：</span>
          <span class="value">{{ detail.finalCustName || '-' }}</span>
        </div>
        <div class="item">
          <span class="label">客户合同编号：</span>
          <span class="value">{{ detail.custContractNo || '-' }}<Copyable  v-if="detail.custContractNo" :text="detail.custContractNo"/></span>
        </div>
        <div class="item">
          <span class="label">中控合同编号：</span>
          <span class="value">{{ detail.contractNo || '-'}}<Copyable  v-if="detail.contractNo" :text="detail.contractNo"/></span>
        </div>
        <div class="item">
          <span class="label">项目经理：</span>
          <span class="value"
            >{{ detail.projManager }} {{ detail.projManagerPhone }}</span
          >
        </div>
        <div class="item">
          <span class="label">销售经理：</span>
          <span class="value"
            >{{ detail.salManager }} {{ detail.salManagerPhone }}</span
          >
        </div>
      </div>
      <el-divider></el-divider>
    </div>
    <div>
      <div>
        <Item v-for="(item, index) in dataList" :key="index" :item="item" />
      </div>
      <el-pagination
        :current-page="dataForm.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="dataForm.limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import Copyable from '@/components/copyable.vue'
import Item from './components/item.vue'
export default {
  components: {
    Copyable,
    Item
  },
  data () {
    return {
      detail: {},
      dataForm: {
        page: 1,
        limit: 10
      },
      total: 0,
      dataLoading: false,
      dataList: []
    }
  },
  created () {
    this.detail = JSON.parse(sessionStorage.getItem('project-detail'))
    this.getInquriyDataList(1)
  },
  methods: {
    // 获取列表数据
    getInquriyDataList (page = this.dataForm.page) {
      this.dataForm.page = page
      if (this.dataLoading) {
        return false
      }
      this.dataLoading = true
      let obj = {
        contractNo: this.detail.contractNo,
        ...this.dataForm,
        packListSize: 5
      }
      this.$http
        .post(`/front/bpm/supcon-goods-delivery/list`, obj)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            this.total = 0
            this.dataList = []
            return false
          }
          this.total = res.data.count || 0
          this.dataList = res.data.dataList || []
        })
        .catch(() => {
          this.dataList = []
          this.total = 0
        })
        .finally(() => {
          this.dataLoading = false
        })
    },
    // 更改分页条数
    pageSizeChangeHandle (val) {
      this.dataForm.limit = val
      this.getInquriyDataList(1)
    },
    handleCurrentChange (val) {
      this.dataForm.page = val
      this.getInquriyDataList()
    }
  }
}
</script>

<style lang="scss" scoped>
.list {
  display: flex;
  flex-wrap: wrap;
  line-height: 28px;
  padding-bottom: 12px;
  .item {
    width: 50%;
    .label{
      color: #666;
    }
    .value {
      color: #333;
    }
    &.full {
      width: 100%;
    }
  }
}
</style>
